export default "/images/vendor/@coreui/icons/svg/flag/cif-bw.svg?7c5aeac25702f9142ff259c5cad697ae";